import { render, staticRenderFns } from "./routing.vue?vue&type=template&id=60be0e05&scoped=true&"
import script from "./routing.vue?vue&type=script&lang=js&"
export * from "./routing.vue?vue&type=script&lang=js&"
import style0 from "./routing.vue?vue&type=style&index=0&id=60be0e05&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60be0e05",
  null
  
)

export default component.exports